import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

export default function CancellationPage() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [cancelling, setCancelling] = useState(false);
  const [cancelled, setCancelled] = useState(false);

  useEffect(() => {
    axios.get(`${API_BASE}/api/courses/public/cancel/${token}`)
      .then(res => {
        setInfo(res.data);
        if (res.data.status === "cancelled") setCancelled(true);
      })
      .catch(err => setError(err.response?.data?.detail || "Ungültiger Link"))
      .finally(() => setLoading(false));
  }, [token]);

  const handleCancel = async () => {
    if (!window.confirm("Sind Sie sicher, dass Sie die Anmeldung stornieren möchten? Der Platz wird sofort freigegeben.")) return;
    setCancelling(true);
    try {
      const res = await axios.post(`${API_BASE}/api/courses/public/cancel/${token}`);
      if (res.data.status === "already_cancelled") {
        setCancelled(true);
      } else {
        setCancelled(true);
      }
    } catch (err) {
      setError(err.response?.data?.detail || "Fehler bei der Stornierung");
    } finally {
      setCancelling(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-sky-50 via-white to-sky-50 flex items-center justify-center px-4">
      <div className="w-full max-w-lg">
        {/* Logo */}
        <div className="text-center mb-6">
          <img src="/fitmacher_logo.png" alt="Fitmacher Schwimmausbildung" style={{ maxWidth: 200, margin: "0 auto" }} />
        </div>

        <div className="rounded-2xl bg-white shadow-lg p-6 sm:p-8">
          {loading ? (
            <div className="text-center py-8">
              <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-sky-600 border-r-transparent" />
              <p className="mt-4 text-slate-500">Lade Anmeldung...</p>
            </div>
          ) : error ? (
            <div className="text-center py-8">
              <div className="text-4xl mb-4">⚠️</div>
              <h3 className="text-lg font-bold text-red-700">Fehler</h3>
              <p className="mt-2 text-slate-600">{error}</p>
            </div>
          ) : cancelled ? (
            <div className="text-center py-4" data-testid="cancellation-success">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-emerald-100 mb-4">
                <svg className="w-8 h-8 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-slate-900">Stornierung erfolgreich</h3>
              <p className="mt-3 text-slate-600">
                Die Anmeldung für <strong>{info?.child_name}</strong> zum Kurs <strong>{info?.course_title}</strong> wurde storniert.
              </p>
              <p className="mt-2 text-sm text-slate-400">Der Platz ist nun wieder für andere Kinder verfügbar.</p>
            </div>
          ) : (
            <div data-testid="cancellation-form">
              <h3 className="text-xl font-bold text-slate-900 mb-4">Anmeldung stornieren</h3>
              <div className="rounded-xl bg-slate-50 p-4 space-y-2">
                <p className="text-sm text-slate-600"><strong>Kind:</strong> {info?.child_name}</p>
                <p className="text-sm text-slate-600"><strong>Kurs:</strong> {info?.course_title}</p>
                <p className="text-sm text-slate-600"><strong>Angemeldet am:</strong> {info?.created_at ? new Date(info.created_at).toLocaleDateString("de-DE") : "—"}</p>
              </div>
              <div className="mt-6 rounded-xl bg-amber-50 border border-amber-200 p-4">
                <p className="text-sm text-amber-800">
                  <strong>Achtung:</strong> Nach der Stornierung wird der Platz sofort freigegeben und kann von anderen Familien gebucht werden.
                </p>
              </div>
              <button
                data-testid="confirm-cancel-btn"
                onClick={handleCancel}
                disabled={cancelling}
                className="mt-6 w-full rounded-xl bg-red-600 px-6 py-3 font-semibold text-white shadow hover:bg-red-700 disabled:opacity-50 transition-colors"
              >
                {cancelling ? "Wird storniert..." : "Anmeldung jetzt stornieren"}
              </button>
            </div>
          )}
        </div>

        <div className="text-center mt-6 text-sm text-slate-400">
          Fragen? <a href="mailto:schwimmausbildung@sfw-berlin.org" className="text-slate-500 underline hover:text-slate-700">schwimmausbildung@sfw-berlin.org</a>
        </div>
      </div>
    </div>
  );
}
